import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { API_BASE_URL } from "../constants";

type HydratedError = Error & { info: unknown; status: number };

export default function useFetcher() {
  const { getToken } = useKindeAuth();

  return async function fetcher<T>(path: string) {
    try {
      const accessToken = await getToken!();
      const headers: HeadersInit = {};

      if (accessToken) {
        headers.Authorization = `Bearer ${accessToken}`;
      }

      const response = await fetch(API_BASE_URL + path, {
        headers,
      });

      if (!response.ok) {
        const error = new Error(
          "An error occurred while fetching the data."
        ) as HydratedError;

        error.info = (await response.json()) as T | undefined;
        error.status = response.status;

        throw error;
      }

      return (await response.json()) as T | undefined;
    } catch (err) {
      console.log(err);
      throw err;
    }
  };
}
